



























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryUserList, BindMedicineCabinet, MCQueryInvestorList, UnbindMedicineCabinet } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { Message, MessageBox } from 'element-ui'

@Component({
  components: { VTable },
})
export default class MCBindUserDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.formData = {}
    this.show = false
  }
  private userOption = []
  private data: any = {}
  private formData: any = {}
  private show = false
  private loading = false

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    userNo: [this.requiredRule],
  }

  private tableData = []

  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '手机号', param: 'mobilePhone' },
    { title: '昵称', param: 'nickname' },
    {
      title: '操作',
      operation: [{ title: '解绑', icon: 'el-icon-delete', class: 'red', click: this.unbind }],
    },
  ]

  public async open(data: any) {
    this.show = true
    this.data = data
    this.loadInvestor()
  }

  private async loadInvestor() {
    const result = await MCQueryInvestorList({ medicineCabinetId: this.data.id })
    this.tableData = result.list
  }

  private async unbind(data: any) {
    // 解绑
    MessageBox.confirm('确定要解绑吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UnbindMedicineCabinet({
        medicineCabinetId: this.data.id,
        investorUserNo: data.userNo,
      })
      // const ruslt = await VideoDelte({ id: data.id })
      if (ruslt) {
        Message.success('解绑成功')
        this.loadInvestor()
      }
    })
  }

  private async remoteMethod(query: string) {
    this.loading = true
    // 防止接口失败
    setTimeout(() => {
      if (this.loading) {
        this.loading = false
      }
    }, 1000)
    const result = await QueryUserList({ role: 2, mobilePhone: query, startRow: 0, limit: 10 })

    const list = result.list
    const m = list.map((e: any) => {
      return { label: e.mobilePhone + '(' + e.nickname + ')', value: e.userNo }
    })

    this.userOption = m

    this.loading = false
  }

  public async save() {
    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        const result = await BindMedicineCabinet({
          medicineCabinetId: this.data.id,
          investorUserNo: this.formData.userNo,
        })

        console.log(result)
        this.loadInvestor()
        // if (result) {
        //   this.close()
        // }
      } else {
        return false
      }
    })
  }
}
